/**
 * mk-card-api
 * 名片C端服务
 *
 * OpenAPI spec version: last
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise } from '@ajax'
import * as models from '../model/models'

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

export interface ParamscardCompanyGet {
  // queryParams
  companyID: string; // 公司id
}
export interface ParamscardDetailGet {
  // queryParams
  companyID: string; // 公司id
  sceneId: string; // sceneId
}
export interface ParamscardListGet {
  // queryParams
  companyID: string; // 公司id
  pageSize: string; // 每页数量 大于0
  page: string; // 页码 最大为10
}
export interface ParamscardMaterialGet {
  // queryParams
  companyID: string; // 公司id
  miniMaterialID: string; // mini id
}
export interface ParamscardUserCardGet {
  // queryParams
  companyId: string; // 公司id
  userId: string; // 员工id
}
export class CardApi {
  protected $basePath = '/card/v1'.replace(/\/$/, '');

  public constructor (basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '')
    }
  }

  /**
   *
   * @summary 获取公司名片
   * @param params ParamscardCompanyGet

   */
  public cardCompanyGet = (
    params: ParamscardCompanyGet

  ) : AjaxPromise<models.CardList> => {
    const path = '/card/company'
    const url = this.$basePath + path
    const p: any = {}
    p.query = {}
    if ('companyID' in params) p.query.companyID = params.companyID
    ajax.check(params.companyID, 'companyID')
    return ajax.ajax({
      method: 'GET',
      url,
      ...p
    }, path, this.$basePath)
  }
  /**
   *
   * @summary 获得名片详情
   * @param params ParamscardDetailGet

   */
  public cardDetailGet = (
    params: ParamscardDetailGet

  ) : AjaxPromise<models.CardList> => {
    const path = '/card/detail'
    const url = this.$basePath + path
    const p: any = {}
    p.query = {}
    if ('companyID' in params) p.query.companyID = params.companyID
    ajax.check(params.companyID, 'companyID')
    if ('sceneId' in params) p.query.sceneId = params.sceneId
    ajax.check(params.sceneId, 'sceneId')
    return ajax.ajax({
      method: 'GET',
      url,
      ...p
    }, path, this.$basePath)
  }
  /**
   *
   * @summary 公司默认个人名片列表
   * @param params ParamscardListGet

   */
  public cardListGet = (
    params: ParamscardListGet

  ) : AjaxPromise<models.CardList> => {
    const path = '/card/list'
    const url = this.$basePath + path
    const p: any = {}
    p.query = {}
    if ('companyID' in params) p.query.companyID = params.companyID
    ajax.check(params.companyID, 'companyID')
    if ('pageSize' in params) p.query.pageSize = params.pageSize
    ajax.check(params.pageSize, 'pageSize')
    if ('page' in params) p.query.page = params.page
    ajax.check(params.page, 'page')
    return ajax.ajax({
      method: 'GET',
      url,
      ...p
    }, path, this.$basePath)
  }
  /**
   *
   * @summary 小程序素材
   * @param params ParamscardMaterialGet

   */
  public cardMaterialGet = (
    params: ParamscardMaterialGet

  ) : AjaxPromise<models.CardList> => {
    const path = '/card/material'
    const url = this.$basePath + path
    const p: any = {}
    p.query = {}
    if ('companyID' in params) p.query.companyID = params.companyID
    ajax.check(params.companyID, 'companyID')
    if ('miniMaterialID' in params) p.query.miniMaterialID = params.miniMaterialID
    ajax.check(params.miniMaterialID, 'miniMaterialID')
    return ajax.ajax({
      method: 'GET',
      url,
      ...p
    }, path, this.$basePath)
  }
  /**
   *
   * @summary 小程序-查找个人名片信息
   * @param params ParamscardUserCardGet

   */
  public cardUserCardGet = (
    params: ParamscardUserCardGet

  ) : AjaxPromise<models.CardUserCard> => {
    const path = '/card/user_card'
    const url = this.$basePath + path
    const p: any = {}
    p.query = {}
    if ('companyId' in params) p.query.companyId = params.companyId
    ajax.check(params.companyId, 'companyId')
    if ('userId' in params) p.query.userId = params.userId
    ajax.check(params.userId, 'userId')
    return ajax.ajax({
      method: 'GET',
      url,
      ...p
    }, path, this.$basePath)
  }
}

export default new CardApi()
